import { IWatermarkSet } from '@/types/watermarks.types';
import { Patch } from '../helpers';
import { watermarkPath } from './path';

export default function UpdateWatermark(watermark: IWatermarkSet) {
  return Patch<IWatermarkSet>({
    path: watermarkPath(watermark.channel) + `/${watermark.uuid}`,
    body: watermark,
  });
}
